<template>
  <div class="address-box" :style="show?'bottom: 0%':'bottom: -40%'" >
    <van-area :show="show" :area-list="areaList" @confirm="confirmAddr" @cancel="cancelAddr"/>
  </div>
</template>

<script>
import { address } from '../../utils/address.js'
export default{
  name: 'SelectAddress',
  data() {
    return {
      areaList:address
    }
  },
  props: {
    show: [Boolean]
  },
  methods:{
    confirmAddr(e){
      this.$emit('confirmAddr',e)
    },
    cancelAddr(){
      this.$emit('cancelAddr')
    }
  }
}
</script>

<style scoped="">
  .address-box{
    position: fixed;
    left: 0;
    width: 100%;
    height: 40%;
    transition: all 0.5s;
    z-index: 999;
    background: #FFFFFF;
  }

</style>



// WEBPACK FOOTER //
// src/views/address/selectAddress.vue